// extracted by mini-css-extract-plugin
export default {"navbarbrand":"SideMenu_navbarbrand__pBQhY","navlink":"SideMenu_navlink__Rj6mS","navlinkicon":"SideMenu_navlinkicon__5l7F2","myactive":"SideMenu_myactive__tCmTx"};